import script from "./DrivetrainBreakdownChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DrivetrainBreakdownChart.vue?vue&type=script&setup=true&lang=js"

import "./DrivetrainBreakdownChart.vue?vue&type=style&index=0&id=25e489f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e489f1"]])

export default __exports__